module.exports = __webpack_public_path__ + "media/images/athletes/1397-100f50acf05d2d4718df062406f25440.png";